// Rapid reload dialog component for the library page

import React from 'react';
import ManageRapidReload from '../loons/ManageRapidReload';
import { analyticsService } from '@/services/analyticsService';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';

const RapidReloadDialog: React.FC<LibraryDialogOutletProps> = ({
  user,
  dialog,
  setDialog,
}) => {
  const [isSavingRapidReload, setIsSavingRapidReload] = React.useState(false);

  if (!user) {
    return null;
  }

  const closeDialog = () => {
    setDialog(null);
  };

  const trackDismiss = () => {
    analyticsService.trackButtonClick('Rapid Reload Dialog Close', {
      surface: 'library_rapid_reload',
      flow_type: 'rapid_reload_setup',
      close_method: 'dismiss',
      link_location: 'library_rapid_reload',
    });
  };

  const blockDismissWhileSaving = (event: Event) => {
    if (isSavingRapidReload) {
      event.preventDefault();
    }
  };

  return (
    <Dialog
      open={dialog === 'rapid-reload'}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          trackDismiss();
          closeDialog();
        }
      }}
    >
      <DialogContent
        showCloseButton={false}
        className="max-h-[85vh] gap-0 overflow-y-auto p-4 sm:max-w-sm"
        onPointerDownOutside={blockDismissWhileSaving}
        onEscapeKeyDown={blockDismissWhileSaving}
      >
        <DialogTitle className="sr-only">Manage Rapid Reload</DialogTitle>
        <DialogDescription className="sr-only">
          Top up your Loons with a single click. You must have a saved payment
          method in the Stripe Customer Portal and a preferred package to use
          this feature.
        </DialogDescription>
        <ManageRapidReload
          onClose={closeDialog}
          onSavingChange={setIsSavingRapidReload}
          analyticsSurface="library_rapid_reload"
          portalReturnUrl="/library?dialog=rapid-reload"
        />
      </DialogContent>
    </Dialog>
  );
};

export default RapidReloadDialog;
